"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getTiktokConnectConfigAction,
  type TiktokConnectConfig,
} from "@/server-actions/tiktok-connect"

export const tiktokConnectConfigQueryKey = ["tiktok-connect-config"] as const

/** Public App ID + whether TikTok can be connected by this user at all. */
export function useTiktokConnectConfigQuery() {
  return useQuery<TiktokConnectConfig>({
    queryKey: tiktokConnectConfigQueryKey,
    queryFn: async () => {
      const result = await getTiktokConnectConfigAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
